import { apolloProvider } from '@/modules/myStageGraphQL';
import {
  GET_CHAT_HISTORY,
  GET_CHAT_EDIT_HISTORY
} from '@/graphql/chatHistory';

import logger from '@/modules/Logger';

export const GetChatHistoryService = {
  msb: async (params, isEditHistory, callback) => {
    logger.info(`[Chat History] Get chat history data from MSB endpoint`, {
      operation: 'chat-history:get'
    });

    const query = isEditHistory ? GET_CHAT_EDIT_HISTORY : GET_CHAT_HISTORY;
    const payload = isEditHistory ? {
      student_book_id: parseInt(params.lessonId),
      message_id: parseInt(params.messageId),
    } : {
      student_book_id: parseInt(params.lessonId),
    };

    let result;
    let errMessage = '';
    let data = null;

    const client = apolloProvider.defaultClient;
    const response = await client.query({
      query: query,
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
      variables: payload
    });

    if (response.errors) {
      let firstError = response.errors;
      if (Array.isArray(firstError) && firstError.length > 0) {
        firstError = firstError[0];
      }
      
      result = false;
      errMessage = {
        response: {
          status: firstError.extensions.status,
          data: firstError.extensions.data,
        }
      };
      logger.error(`[Chat History] Chat history data fetch failed: ${firstError.message}`, {
        event_type: 36,
        payload: payload,
        lesson_id: parseInt(params.bookingId)
      });
      callback(null);
    } else if (isEditHistory && response.data?.getChatsEditHistory.message_id) {
      result = true;
      data = response.data.getChatsEditHistory;
      callback(data);
    } else if (!isEditHistory && response.data?.getChatsHistory.lesson_details) {
      result = true;
      data = response.data.getChatsHistory;
      callback(data);
    } else {
      result = false;
      errMessage = 'Error fetching chat data';
      logger.error(`[Chat History] Error fetching chat data`, {
        operation: 'chat-history:get'
      });
      callback(null);
    }

    return { result, data, errMessage };
  },

  legacy: async (params, isEditHistory, callback) => {
    logger.info(`[Chat History]  Get chat history data from LEGACY endpoint - skipped`, {
      operation: 'chat-history:get',
      payload: {
        params, isEditHistory, callback
      }
    });

    callback(null);
    
    // force error - return to Lesson page?
    return { 
      result: false,
      data: null,
      errMessage: {
        response: {
          status: 422
        }
      }
    };
  }
};
